import { styled } from '@mui/material';
import { ReactComponent as building_line } from 'assets/icons/building.svg';

const BuildingIcon = styled(building_line)`
  path {
    fill: ${({ color }) => color || 'initial'};
  }
`;

const UserIcon = ({ fill }) => {
  return (
    <svg
      width='17'
      height='18'
      viewBox='0 0 17 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_189_2120)'>
        <path
          d='M8.5 8.80615C9.34057 8.80615 10.1623 8.5569 10.8612 8.0899C11.5601 7.6229 12.1048 6.95914 12.4265 6.18256C12.7482 5.40597 12.8323 4.55144 12.6683 3.72702C12.5044 2.9026 12.0996 2.14532 11.5052 1.55095C10.9108 0.956577 10.1536 0.551804 9.32913 0.387817C8.50471 0.22383 7.65018 0.307994 6.8736 0.629666C6.09701 0.951339 5.43325 1.49607 4.96625 2.19498C4.49926 2.89389 4.25 3.71558 4.25 4.55615C4.25113 5.68298 4.69925 6.76333 5.49604 7.56012C6.29282 8.3569 7.37318 8.80503 8.5 8.80615ZM8.5 1.72282C9.06038 1.72282 9.60818 1.88899 10.0741 2.20032C10.5401 2.51165 10.9032 2.95416 11.1177 3.47188C11.3321 3.98961 11.3882 4.5593 11.2789 5.10891C11.1696 5.65852 10.8997 6.16337 10.5035 6.55962C10.1072 6.95587 9.60237 7.22572 9.05276 7.33505C8.50314 7.44437 7.93345 7.38826 7.41573 7.17381C6.89801 6.95936 6.4555 6.59621 6.14417 6.13027C5.83284 5.66433 5.66667 5.11653 5.66667 4.55615C5.66667 3.80471 5.96518 3.08404 6.49653 2.55269C7.02788 2.02133 7.74855 1.72282 8.5 1.72282Z'
          fill={fill || '#7F56D9'}
        />
        <path
          d='M8.5 10.2231C6.80982 10.225 5.1894 10.8973 3.99426 12.0924C2.79913 13.2875 2.12687 14.908 2.125 16.5981C2.125 16.786 2.19963 16.9662 2.33247 17.099C2.4653 17.2319 2.64547 17.3065 2.83333 17.3065C3.02119 17.3065 3.20136 17.2319 3.3342 17.099C3.46704 16.9662 3.54167 16.786 3.54167 16.5981C3.54167 15.2831 4.06406 14.0219 4.99393 13.0921C5.9238 12.1622 7.18497 11.6398 8.5 11.6398C9.81503 11.6398 11.0762 12.1622 12.0061 13.0921C12.9359 14.0219 13.4583 15.2831 13.4583 16.5981C13.4583 16.786 13.533 16.9662 13.6658 17.099C13.7986 17.2319 13.9788 17.3065 14.1667 17.3065C14.3545 17.3065 14.5347 17.2319 14.6675 17.099C14.8004 16.9662 14.875 16.786 14.875 16.5981C14.8731 14.908 14.2009 13.2875 13.0057 12.0924C11.8106 10.8973 10.1902 10.225 8.5 10.2231Z'
          fill={fill || '#7F56D9'}
        />
      </g>
      <defs>
        <clipPath id='clip0_189_2120'>
          <rect
            width='17'
            height='17'
            fill='white'
            transform='translate(0 0.306152)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const CalendarIcon = ({ fill }) => (
  <svg
    width='17'
    height='17'
    viewBox='0 0 17 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_189_2151)'>
      <path
        d='M13.112 2.21761H12.4531V1.55876C12.4531 1.38402 12.3837 1.21644 12.2602 1.09288C12.1366 0.969317 11.969 0.899902 11.7943 0.899902C11.6195 0.899902 11.4519 0.969317 11.3284 1.09288C11.2048 1.21644 11.1354 1.38402 11.1354 1.55876V2.21761H5.86458V1.55876C5.86458 1.38402 5.79517 1.21644 5.67161 1.09288C5.54805 0.969317 5.38047 0.899902 5.20573 0.899902C5.03099 0.899902 4.86341 0.969317 4.73985 1.09288C4.61629 1.21644 4.54688 1.38402 4.54688 1.55876V2.21761H3.88802C3.01465 2.21866 2.17734 2.56607 1.55978 3.18364C0.942206 3.8012 0.594796 4.63851 0.59375 5.51188L0.59375 13.4181C0.594796 14.2915 0.942206 15.1288 1.55978 15.7464C2.17734 16.3639 3.01465 16.7114 3.88802 16.7124H13.112C13.9854 16.7114 14.8227 16.3639 15.4402 15.7464C16.0578 15.1288 16.4052 14.2915 16.4063 13.4181V5.51188C16.4052 4.63851 16.0578 3.8012 15.4402 3.18364C14.8227 2.56607 13.9854 2.21866 13.112 2.21761V2.21761ZM1.91146 5.51188C1.91146 4.98766 2.1197 4.48492 2.49038 4.11424C2.86106 3.74356 3.3638 3.53532 3.88802 3.53532H13.112C13.6362 3.53532 14.1389 3.74356 14.5096 4.11424C14.8803 4.48492 15.0885 4.98766 15.0885 5.51188V6.17074H1.91146V5.51188ZM13.112 15.3947H3.88802C3.3638 15.3947 2.86106 15.1865 2.49038 14.8158C2.1197 14.4451 1.91146 13.9423 1.91146 13.4181V7.48844H15.0885V13.4181C15.0885 13.9423 14.8803 14.4451 14.5096 14.8158C14.1389 15.1865 13.6362 15.3947 13.112 15.3947Z'
        fill={fill || '#7F56D9'}
      />
      <path
        d='M8.5 11.771C9.04581 11.771 9.48828 11.3285 9.48828 10.7827C9.48828 10.2369 9.04581 9.79443 8.5 9.79443C7.95419 9.79443 7.51172 10.2369 7.51172 10.7827C7.51172 11.3285 7.95419 11.771 8.5 11.771Z'
        fill={fill || '#7F56D9'}
      />
      <path
        d='M5.20605 11.771C5.75187 11.771 6.19434 11.3285 6.19434 10.7827C6.19434 10.2369 5.75187 9.79443 5.20605 9.79443C4.66024 9.79443 4.21777 10.2369 4.21777 10.7827C4.21777 11.3285 4.66024 11.771 5.20605 11.771Z'
        fill={fill || '#7F56D9'}
      />
      <path
        d='M11.7939 11.771C12.3398 11.771 12.7822 11.3285 12.7822 10.7827C12.7822 10.2369 12.3398 9.79443 11.7939 9.79443C11.2481 9.79443 10.8057 10.2369 10.8057 10.7827C10.8057 11.3285 11.2481 11.771 11.7939 11.771Z'
        fill={fill || '#7F56D9'}
      />
    </g>
    <defs>
      <clipPath id='clip0_189_2151'>
        <rect
          width='15.8125'
          height='15.8125'
          fill='white'
          transform='translate(0.59375 0.899902)'
        />
      </clipPath>
    </defs>
  </svg>
);

const CakeIcon = ({ fill }) => (
  <svg
    width='17'
    height='17'
    viewBox='0 0 17 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_189_2180)'>
      <path
        d='M15.7474 15.395H15.0885V10.1241C15.0875 9.25077 14.7401 8.41346 14.1225 7.79589C13.5049 7.17832 12.6676 6.83091 11.7943 6.82987H9.15885V4.879C9.45236 4.75091 9.70216 4.54003 9.87768 4.27218C10.0532 4.00433 10.1468 3.69112 10.1471 3.37088C9.96916 2.52872 9.56822 1.74983 8.98623 1.11563C8.9245 1.04811 8.84939 0.994195 8.76567 0.957307C8.68196 0.920418 8.59148 0.901367 8.5 0.901367C8.40852 0.901367 8.31804 0.920418 8.23433 0.957307C8.15061 0.994195 8.0755 1.04811 8.01377 1.11563C7.43178 1.74983 7.03084 2.52872 6.85286 3.37088C6.85316 3.69112 6.9468 4.00433 7.12232 4.27218C7.29785 4.54003 7.54764 4.75091 7.84115 4.879V6.82987H5.20573C4.33236 6.83091 3.49505 7.17832 2.87748 7.79589C2.25991 8.41346 1.9125 9.25077 1.91146 10.1241V15.395H1.2526C1.07787 15.395 0.910283 15.4644 0.786724 15.5879C0.663165 15.7115 0.59375 15.8791 0.59375 16.0538C0.59375 16.2286 0.663165 16.3961 0.786724 16.5197C0.910283 16.6433 1.07787 16.7127 1.2526 16.7127H15.7474C15.9221 16.7127 16.0897 16.6433 16.2133 16.5197C16.3368 16.3961 16.4063 16.2286 16.4063 16.0538C16.4063 15.8791 16.3368 15.7115 16.2133 15.5879C16.0897 15.4644 15.9221 15.395 15.7474 15.395ZM5.20573 8.14758H11.7943C12.3185 8.14758 12.8212 8.35582 13.1919 8.7265C13.5626 9.09718 13.7708 9.59992 13.7708 10.1241V11.4287C13.1541 11.3628 12.7826 10.9675 12.7826 10.783C12.7826 10.6083 12.7131 10.4407 12.5896 10.3171C12.466 10.1936 12.2984 10.1241 12.1237 10.1241C11.949 10.1241 11.7814 10.1936 11.6578 10.3171C11.5343 10.4407 11.4648 10.6083 11.4648 10.783C11.4648 11.009 11.0155 11.4418 10.3118 11.4418C9.59436 11.4418 9.15885 10.9846 9.15885 10.783C9.15885 10.6083 9.08944 10.4407 8.96588 10.3171C8.84232 10.1936 8.67474 10.1241 8.5 10.1241C8.32526 10.1241 8.15768 10.1936 8.03412 10.3171C7.91056 10.4407 7.84115 10.6083 7.84115 10.783C7.84115 11.009 7.39181 11.4418 6.68815 11.4418C5.97066 11.4418 5.53516 10.9846 5.53516 10.783C5.53516 10.6083 5.46574 10.4407 5.34218 10.3171C5.21862 10.1936 5.05104 10.1241 4.8763 10.1241C4.70156 10.1241 4.53398 10.1936 4.41042 10.3171C4.28686 10.4407 4.21745 10.6083 4.21745 10.783C4.21745 10.9905 3.83597 11.3681 3.22917 11.4293V10.1241C3.22917 9.59992 3.43741 9.09718 3.80809 8.7265C4.17877 8.35582 4.68151 8.14758 5.20573 8.14758V8.14758ZM3.22917 12.7457C3.83445 12.7189 4.41374 12.492 4.8763 12.1007C5.38452 12.5243 6.02474 12.7572 6.68637 12.759C7.348 12.7608 7.98948 12.5314 8.5 12.1106C9.01052 12.5314 9.652 12.7608 10.3136 12.759C10.9753 12.7572 11.6155 12.5243 12.1237 12.1007C12.5863 12.4918 13.1656 12.7184 13.7708 12.7451V15.395H3.22917V12.7457Z'
        fill={fill || '#7F56D9'}
      />
    </g>
    <defs>
      <clipPath id='clip0_189_2180'>
        <rect
          width='15.8125'
          height='15.8125'
          fill='white'
          transform='translate(0.59375 0.899902)'
        />
      </clipPath>
    </defs>
  </svg>
);

const CommentUserIcon = ({ fill }) => (
  <svg
    width='17'
    height='18'
    viewBox='0 0 17 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_189_2130)'>
      <path
        d='M8.5 7.38949C7.93641 7.38949 7.39591 7.1656 6.9974 6.76709C6.59888 6.36857 6.375 5.82807 6.375 5.26449C6.375 4.7009 6.59888 4.1604 6.9974 3.76188C7.39591 3.36337 7.93641 3.13949 8.5 3.13949C9.06358 3.13949 9.60409 3.36337 10.0026 3.76188C10.4011 4.1604 10.625 4.7009 10.625 5.26449C10.625 5.82807 10.4011 6.36857 10.0026 6.76709C9.60409 7.1656 9.06358 7.38949 8.5 7.38949V7.38949ZM6.35233 11.1075C6.49799 10.6524 6.78446 10.2554 7.17041 9.97371C7.55636 9.69201 8.02183 9.5402 8.49965 9.5402C8.97747 9.5402 9.44293 9.69201 9.82888 9.97371C10.2148 10.2554 10.5013 10.6524 10.647 11.1075C10.6939 11.2896 10.8113 11.4455 10.9732 11.541C11.1351 11.6365 11.3284 11.6638 11.5104 11.6168C11.6925 11.5699 11.8484 11.4525 11.9439 11.2906C12.0394 11.1286 12.0667 10.9354 12.0197 10.7534C11.0911 7.24924 5.90679 7.25065 4.981 10.7534C4.95543 10.8441 4.94824 10.9391 4.95987 11.0327C4.9715 11.1263 5.0017 11.2167 5.04871 11.2984C5.09572 11.3802 5.15859 11.4518 5.23362 11.5089C5.30866 11.5661 5.39435 11.6077 5.48568 11.6312C5.577 11.6548 5.67211 11.6599 5.76544 11.6463C5.85876 11.6326 5.94842 11.6004 6.02915 11.5516C6.10987 11.5029 6.18004 11.4385 6.23554 11.3622C6.29104 11.2859 6.33075 11.1993 6.35233 11.1075V11.1075ZM8.50637 17.0689C8.15692 17.0691 7.81959 16.9407 7.55862 16.7083L4.90379 14.4728H2.83333C2.08189 14.4728 1.36122 14.1743 0.829864 13.643C0.298511 13.1116 0 12.3909 0 11.6395V3.13949C0 2.38804 0.298511 1.66737 0.829864 1.13602C1.36122 0.604663 2.08189 0.306152 2.83333 0.306152L14.1667 0.306152C14.9181 0.306152 15.6388 0.604663 16.1701 1.13602C16.7015 1.66737 17 2.38804 17 3.13949V11.6395C17 12.3909 16.7015 13.1116 16.1701 13.643C15.6388 14.1743 14.9181 14.4728 14.1667 14.4728H12.1458L9.42083 16.7253C9.16838 16.948 8.84298 17.0702 8.50637 17.0689V17.0689ZM2.83333 1.72282C2.45761 1.72282 2.09728 1.87207 1.8316 2.13775C1.56592 2.40343 1.41667 2.76376 1.41667 3.13949V11.6395C1.41667 12.0152 1.56592 12.3755 1.8316 12.6412C2.09728 12.9069 2.45761 13.0562 2.83333 13.0562H5.16304C5.32996 13.0562 5.49152 13.1151 5.61921 13.2226L8.48512 15.638L11.4403 13.2184C11.5673 13.1135 11.7268 13.0561 11.8915 13.0562H14.1667C14.5424 13.0562 14.9027 12.9069 15.1684 12.6412C15.4341 12.3755 15.5833 12.0152 15.5833 11.6395V3.13949C15.5833 2.76376 15.4341 2.40343 15.1684 2.13775C14.9027 1.87207 14.5424 1.72282 14.1667 1.72282H2.83333Z'
        fill={fill || '#7F56D9'}
      />
    </g>
    <defs>
      <clipPath id='clip0_189_2130'>
        <rect
          width='17'
          height='17'
          fill='white'
          transform='translate(0 0.306152)'
        />
      </clipPath>
    </defs>
  </svg>
);

const BrowserIcon = ({ fill }) => (
  <svg
    width='17'
    height='17'
    viewBox='0 0 17 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_189_2184)'>
      <path
        d='M13.112 1.55859H3.88802C3.01465 1.55964 2.17734 1.90705 1.55978 2.52462C0.942206 3.14219 0.594796 3.97949 0.59375 4.85286L0.59375 12.7591C0.594796 13.6325 0.942206 14.4698 1.55978 15.0874C2.17734 15.7049 3.01465 16.0523 3.88802 16.0534H13.112C13.9854 16.0523 14.8227 15.7049 15.4402 15.0874C16.0578 14.4698 16.4052 13.6325 16.4063 12.7591V4.85286C16.4052 3.97949 16.0578 3.14219 15.4402 2.52462C14.8227 1.90705 13.9854 1.55964 13.112 1.55859V1.55859ZM3.88802 2.8763H13.112C13.6362 2.8763 14.1389 3.08455 14.5096 3.45522C14.8803 3.8259 15.0885 4.32865 15.0885 4.85286V5.51172H1.91146V4.85286C1.91146 4.32865 2.1197 3.8259 2.49038 3.45522C2.86106 3.08455 3.3638 2.8763 3.88802 2.8763V2.8763ZM13.112 14.7357H3.88802C3.3638 14.7357 2.86106 14.5274 2.49038 14.1568C2.1197 13.7861 1.91146 13.2833 1.91146 12.7591V6.82943H15.0885V12.7591C15.0885 13.2833 14.8803 13.7861 14.5096 14.1568C14.1389 14.5274 13.6362 14.7357 13.112 14.7357ZM13.112 9.46484C13.112 9.63958 13.0426 9.80717 12.919 9.93072C12.7954 10.0543 12.6279 10.1237 12.4531 10.1237H4.54688C4.37214 10.1237 4.20455 10.0543 4.08099 9.93072C3.95744 9.80717 3.88802 9.63958 3.88802 9.46484C3.88802 9.2901 3.95744 9.12252 4.08099 8.99896C4.20455 8.8754 4.37214 8.80599 4.54688 8.80599H12.4531C12.6279 8.80599 12.7954 8.8754 12.919 8.99896C13.0426 9.12252 13.112 9.2901 13.112 9.46484ZM10.4766 12.1003C10.4766 12.275 10.4071 12.4426 10.2836 12.5661C10.16 12.6897 9.99245 12.7591 9.81771 12.7591H4.54688C4.37214 12.7591 4.20455 12.6897 4.08099 12.5661C3.95744 12.4426 3.88802 12.275 3.88802 12.1003C3.88802 11.9255 3.95744 11.7579 4.08099 11.6344C4.20455 11.5108 4.37214 11.4414 4.54688 11.4414H9.81771C9.99245 11.4414 10.16 11.5108 10.2836 11.6344C10.4071 11.7579 10.4766 11.9255 10.4766 12.1003ZM2.57031 4.19401C2.57031 4.0637 2.60895 3.93632 2.68135 3.82797C2.75375 3.71962 2.85664 3.63518 2.97703 3.58531C3.09742 3.53544 3.2299 3.52239 3.3577 3.54782C3.48551 3.57324 3.6029 3.63599 3.69505 3.72813C3.78719 3.82027 3.84994 3.93767 3.87536 4.06547C3.90078 4.19328 3.88774 4.32575 3.83787 4.44614C3.788 4.56653 3.70355 4.66943 3.59521 4.74183C3.48686 4.81422 3.35948 4.85286 3.22917 4.85286C3.05443 4.85286 2.88685 4.78345 2.76329 4.65989C2.63973 4.53633 2.57031 4.36875 2.57031 4.19401ZM4.54688 4.19401C4.54688 4.0637 4.58552 3.93632 4.65791 3.82797C4.73031 3.71962 4.83321 3.63518 4.9536 3.58531C5.07399 3.53544 5.20646 3.52239 5.33427 3.54782C5.46207 3.57324 5.57947 3.63599 5.67161 3.72813C5.76375 3.82027 5.8265 3.93767 5.85192 4.06547C5.87735 4.19328 5.8643 4.32575 5.81443 4.44614C5.76456 4.56653 5.68012 4.66943 5.57177 4.74183C5.46342 4.81422 5.33604 4.85286 5.20573 4.85286C5.03099 4.85286 4.86341 4.78345 4.73985 4.65989C4.61629 4.53633 4.54688 4.36875 4.54688 4.19401ZM6.52344 4.19401C6.52344 4.0637 6.56208 3.93632 6.63447 3.82797C6.70687 3.71962 6.80977 3.63518 6.93016 3.58531C7.05055 3.53544 7.18302 3.52239 7.31083 3.54782C7.43863 3.57324 7.55603 3.63599 7.64817 3.72813C7.74031 3.82027 7.80306 3.93767 7.82849 4.06547C7.85391 4.19328 7.84086 4.32575 7.79099 4.44614C7.74113 4.56653 7.65668 4.66943 7.54833 4.74183C7.43998 4.81422 7.3126 4.85286 7.18229 4.85286C7.00755 4.85286 6.83997 4.78345 6.71641 4.65989C6.59285 4.53633 6.52344 4.36875 6.52344 4.19401Z'
        fill={fill || '#7F56D9'}
      />
    </g>
    <defs>
      <clipPath id='clip0_189_2184'>
        <rect
          width='15.8125'
          height='15.8125'
          fill='white'
          transform='translate(0.59375 0.899902)'
        />
      </clipPath>
    </defs>
  </svg>
);

const PhoneIcon = ({ fill }) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_189_2176)'>
      <path
        d='M14.0681 10.6287C14.4118 10.9734 14.6048 11.4402 14.6048 11.9269C14.6048 12.4135 14.4118 12.8804 14.0681 13.225L13.5273 13.8476C8.66987 18.4957 -3.14837 6.68103 1.42972 1.80939L2.1111 1.21637C2.45629 0.882364 2.91899 0.697515 3.3993 0.701731C3.87961 0.705947 4.339 0.89889 4.67827 1.2389C4.69606 1.25729 5.79492 2.68527 5.79492 2.68527C6.12089 3.02771 6.30239 3.48257 6.30173 3.95534C6.30107 4.42811 6.11829 4.88246 5.79137 5.22398L5.10406 6.08801C5.48409 7.0114 6.04284 7.8506 6.74821 8.55739C7.45357 9.26418 8.29164 9.82462 9.21426 10.2065L10.083 9.51565C10.4245 9.1889 10.8787 9.00623 11.3514 9.00557C11.824 9.0049 12.2787 9.1863 12.6212 9.51209C12.6212 9.51209 14.0497 10.611 14.0681 10.6287ZM13.2527 11.491C13.2527 11.491 11.8336 10.3987 11.8152 10.3809C11.6931 10.2597 11.528 10.1918 11.3559 10.1918C11.1839 10.1918 11.0188 10.2597 10.8967 10.3809C10.8806 10.3963 9.68453 11.3499 9.68453 11.3499C9.60392 11.414 9.50799 11.4561 9.40619 11.4719C9.30439 11.4877 9.20023 11.4767 9.10396 11.44C7.90797 10.9952 6.82166 10.2984 5.91878 9.39672C5.01589 8.49506 4.31755 7.40971 3.87118 6.21432C3.83212 6.11714 3.81951 6.01134 3.83461 5.9077C3.84972 5.80406 3.892 5.70627 3.95716 5.62427C3.95716 5.62427 4.91014 4.42815 4.92615 4.41214C5.04729 4.28997 5.11525 4.12489 5.11525 3.95285C5.11525 3.7808 5.04729 3.61573 4.92615 3.49356C4.90836 3.47577 3.81602 2.05608 3.81602 2.05608C3.6921 1.94482 3.53031 1.88517 3.36382 1.88936C3.19732 1.89355 3.03874 1.96126 2.92057 2.07862L2.23919 2.67163C-1.1078 6.69348 9.13539 16.3692 12.6597 13.0388L13.2005 12.4161C13.328 12.2991 13.4048 12.1369 13.4146 11.9641C13.4243 11.7914 13.3663 11.6216 13.2527 11.491Z'
        fill={fill || '#7F56D9'}
      />
    </g>
    <defs>
      <clipPath id='clip0_189_2176'>
        <rect
          width='14.2324'
          height='14.2324'
          fill='white'
          transform='translate(0.383789 0.689941)'
        />
      </clipPath>
    </defs>
  </svg>
);

const NoImageIcon = ({ fill }) => (
  <svg
    width='43'
    height='43'
    viewBox='0 0 43 43'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M41.8538 0.952148C41.2288 0.327148 40.208 0.327148 39.583 0.952148L1.14551 39.4105C0.520508 40.0355 0.520508 41.0563 1.14551 41.6813C1.29382 41.8291 1.47004 41.946 1.66393 42.025C1.85782 42.1041 2.06549 42.1438 2.27487 42.1419C2.48425 42.1399 2.69115 42.0964 2.88354 42.0137C3.07593 41.9311 3.24996 41.811 3.39551 41.6605L41.8538 3.20215C42.4997 2.57715 42.4997 1.57715 41.8538 0.952148ZM15.2497 17.9313C16.5647 17.9313 17.8259 17.4089 18.7557 16.4791C19.6856 15.5492 20.208 14.288 20.208 12.973C20.208 11.658 19.6856 10.3968 18.7557 9.46691C17.8259 8.53704 16.5647 8.01465 15.2497 8.01465C13.9346 8.01465 12.6735 8.53704 11.7436 9.46691C10.8137 10.3968 10.2913 11.658 10.2913 12.973C10.2913 14.288 10.8137 15.5492 11.7436 16.4791C12.6735 17.4089 13.9346 17.9313 15.2497 17.9313ZM41.5205 7.53548L38.9788 10.0771C39.1455 10.848 39.208 11.6813 39.208 12.5771V22.5771L38.9372 22.348C37.3122 20.9522 34.6872 20.9522 33.0622 22.348L24.3955 29.7855C22.9163 31.0563 20.583 31.1813 18.958 30.098L7.74967 41.3063C7.83301 41.348 7.91634 41.3688 7.99967 41.3897C8.56217 41.5772 9.12467 41.723 9.72884 41.848C9.93717 41.8897 10.1455 41.9313 10.3747 41.9522C11.1455 42.0563 11.9372 42.1397 12.7705 42.1397H30.2288C37.8122 42.1397 42.333 37.6188 42.333 30.0355V12.5771C42.333 10.7021 42.0622 9.01465 41.5205 7.53548Z'
      fill={fill || '#949494'}
    />
    <path
      d='M41.5212 7.53516L38.9795 10.0768C39.1462 10.8477 39.2087 11.681 39.2087 12.5768V22.5768L38.9378 22.3477C37.3128 20.9518 34.6878 20.9518 33.0628 22.3477L24.3962 29.7852C22.917 31.056 20.5837 31.181 18.9587 30.0977L7.72949 41.3268C9.20866 41.8685 10.8962 42.1393 12.7712 42.1393H30.2295C37.8128 42.1393 42.3337 37.6185 42.3337 30.0352V12.5768C42.3337 10.7018 42.0628 9.01432 41.5212 7.53516ZM39.1253 3.68099L36.917 5.88932C35.417 4.36849 33.167 3.59766 30.2295 3.59766H12.7712C6.89616 3.59766 3.79199 6.70182 3.79199 12.5768V30.0352C3.79199 31.6185 4.06283 32.9727 4.52116 34.1393L12.3128 28.9102C13.0212 28.431 13.8337 28.181 14.6462 28.1602L3.87533 38.931C3.04199 38.0977 2.35449 37.0977 1.83366 35.9518C1.06283 34.2852 0.666992 32.306 0.666992 30.0352V12.5768C0.666992 4.99349 5.18783 0.472656 12.7712 0.472656H30.2295C34.0212 0.472656 37.042 1.59766 39.1253 3.68099Z'
      fill={fill || '#949494'}
    />
  </svg>
);

const LocationIcon = ({ fill }) => (
  <svg
    width='17'
    height='17'
    viewBox='0 0 17 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_189_2142)'>
      <path
        d='M8.50016 0.806152C7.04754 0.806185 5.62766 1.23763 4.42058 2.04576C3.21351 2.8539 2.27364 4.00232 1.72016 5.34536C1.16669 6.68841 1.02455 8.16558 1.31178 9.58952C1.59901 11.0135 2.30266 12.32 3.3335 13.3435L5.96216 15.7708C6.63782 16.4322 7.54497 16.8037 8.49045 16.8062C9.43593 16.8087 10.345 16.442 11.0242 15.7842L13.6855 13.3248C14.711 12.2992 15.4094 10.9926 15.6924 9.57009C15.9753 8.14759 15.8301 6.67314 15.2751 5.33317C14.72 3.99321 13.7801 2.84792 12.5742 2.04212C11.3683 1.23632 9.95053 0.806198 8.50016 0.806152V0.806152ZM12.7615 12.3642L10.1055 14.8182C9.66877 15.2296 9.09079 15.4578 8.49077 15.4555C7.89075 15.4533 7.31448 15.2209 6.88083 14.8062L4.2575 12.3822C3.5598 11.6844 3.04493 10.8254 2.75851 9.88122C2.47209 8.93701 2.42296 7.93672 2.61545 6.96898C2.80795 6.00124 3.23614 5.09591 3.8621 4.33318C4.48806 3.57045 5.29246 2.97386 6.20405 2.59626C7.11565 2.21867 8.1063 2.07172 9.08825 2.16843C10.0702 2.26514 11.0131 2.60253 11.8336 3.1507C12.654 3.69888 13.3265 4.44093 13.7917 5.31112C14.2568 6.18131 14.5002 7.15278 14.5002 8.13949C14.5031 8.92351 14.351 9.70037 14.0526 10.4254C13.7542 11.1504 13.3154 11.8093 12.7615 12.3642ZM11.6402 5.91482L9.64016 4.52749C9.30509 4.29595 8.90745 4.17193 8.50016 4.17193C8.09287 4.17193 7.69524 4.29595 7.36016 4.52749L5.36016 5.91482C5.09477 6.09893 4.87792 6.34458 4.72815 6.63077C4.57838 6.91695 4.50016 7.23515 4.50016 7.55815V9.80615C4.50016 10.2482 4.67576 10.6721 4.98832 10.9847C5.30088 11.2972 5.7248 11.4728 6.16683 11.4728H10.8335C11.2755 11.4728 11.6994 11.2972 12.012 10.9847C12.3246 10.6721 12.5002 10.2482 12.5002 9.80615V7.55815C12.5002 7.23515 12.4219 6.91695 12.2722 6.63077C12.1224 6.34458 11.9056 6.09893 11.6402 5.91482ZM11.1668 9.80615C11.1668 9.89456 11.1317 9.97934 11.0692 10.0419C11.0067 10.1044 10.9219 10.1395 10.8335 10.1395H9.8335V8.80615C9.8335 8.62934 9.76326 8.45977 9.63823 8.33475C9.51321 8.20972 9.34364 8.13949 9.16683 8.13949H7.8335C7.65669 8.13949 7.48712 8.20972 7.36209 8.33475C7.23707 8.45977 7.16683 8.62934 7.16683 8.80615V10.1395H6.16683C6.07842 10.1395 5.99364 10.1044 5.93113 10.0419C5.86861 9.97934 5.8335 9.89456 5.8335 9.80615V7.55815C5.83346 7.45045 5.85952 7.34434 5.90944 7.2489C5.95936 7.15346 6.03167 7.07155 6.12016 7.01015L8.12016 5.62282C8.23197 5.54594 8.36447 5.50478 8.50016 5.50478C8.63585 5.50478 8.76835 5.54594 8.88016 5.62282L10.8802 7.01015C10.9687 7.07155 11.041 7.15346 11.0909 7.2489C11.1408 7.34434 11.1669 7.45045 11.1668 7.55815V9.80615Z'
        fill={fill || '#7F56D9'}
      />
    </g>
    <defs>
      <clipPath id='clip0_189_2142'>
        <rect
          width='16'
          height='16'
          fill='white'
          transform='translate(0.5 0.806152)'
        />
      </clipPath>
    </defs>
  </svg>
);

const StarNoThingIcon = () => (
  <svg
    width='25'
    height='25'
    viewBox='0 0 25 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.1239 1.66384C11.8381 0.800319 13.1619 0.800318 13.8761 1.66384L16.3266 4.62682C16.5997 4.95707 16.9825 5.17808 17.4051 5.24949L21.1964 5.89021C22.3013 6.07694 22.9632 7.22338 22.5724 8.27363L21.2317 11.8773C21.0822 12.279 21.0822 12.721 21.2317 13.1227L22.5724 16.7264C22.9632 17.7766 22.3013 18.9231 21.1964 19.1098L17.4051 19.7505C16.9825 19.8219 16.5997 20.0429 16.3266 20.3732L13.8761 23.3362C13.1619 24.1997 11.8381 24.1997 11.1239 23.3362L8.67342 20.3732C8.40029 20.0429 8.01749 19.8219 7.59491 19.7505L3.80365 19.1098C2.69873 18.9231 2.03683 17.7766 2.42758 16.7264L3.76833 13.1227C3.91777 12.721 3.91777 12.279 3.76833 11.8773L2.42758 8.27363C2.03683 7.22338 2.69873 6.07694 3.80365 5.89021L7.59491 5.24949C8.01749 5.17808 8.40029 4.95707 8.67342 4.62682L11.1239 1.66384Z'
      fill='url(#paint0_linear_577_2854)'
    />
    <path
      d='M15.3001 9.70011C15.2126 9.61262 15.0939 9.56348 14.9702 9.56348C14.8464 9.56348 14.7278 9.61262 14.6402 9.70011L12.5001 11.8402L10.36 9.70011C10.2725 9.61262 10.1538 9.56348 10.03 9.56348C9.9063 9.56348 9.78762 9.61262 9.70011 9.70011C9.61262 9.78762 9.56348 9.9063 9.56348 10.03C9.56348 10.1538 9.61262 10.2725 9.70011 10.36L11.8402 12.5001L9.70011 14.6402C9.61262 14.7278 9.56348 14.8464 9.56348 14.9702C9.56348 15.0939 9.61262 15.2126 9.70011 15.3001C9.78762 15.3876 9.9063 15.4367 10.03 15.4367C10.1538 15.4367 10.2725 15.3876 10.36 15.3001L12.5001 13.16L14.6402 15.3001C14.7278 15.3876 14.8464 15.4367 14.9702 15.4367C15.0939 15.4367 15.2126 15.3876 15.3001 15.3001C15.3876 15.2126 15.4367 15.0939 15.4367 14.9702C15.4367 14.8464 15.3876 14.7278 15.3001 14.6402L13.16 12.5001L15.3001 10.36C15.3876 10.2725 15.4367 10.1538 15.4367 10.03C15.4367 9.9063 15.3876 9.78762 15.3001 9.70011Z'
      fill='#595959'
    />
    <defs>
      <linearGradient
        id='paint0_linear_577_2854'
        x1='23.913'
        y1='-3.80435'
        x2='2.17391'
        y2='30.9783'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFD9AC' />
        <stop offset='1' stopColor='#FFD964' />
      </linearGradient>
    </defs>
  </svg>
);

const SuperStarIcons = () => (
  <svg
    width='25'
    height='26'
    viewBox='0 0 25 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g filter='url(#filter0_d_578_2853)'>
      <path
        d='M11.1239 1.66384C11.8381 0.800319 13.1619 0.800318 13.8761 1.66384L16.3266 4.62682C16.5997 4.95707 16.9825 5.17808 17.4051 5.24949L21.1964 5.89021C22.3013 6.07694 22.9632 7.22338 22.5724 8.27363L21.2317 11.8773C21.0822 12.279 21.0822 12.721 21.2317 13.1227L22.5724 16.7264C22.9632 17.7766 22.3013 18.9231 21.1964 19.1098L17.4051 19.7505C16.9825 19.8219 16.5997 20.0429 16.3266 20.3732L13.8761 23.3362C13.1619 24.1997 11.8381 24.1997 11.1239 23.3362L8.67342 20.3732C8.40029 20.0429 8.01749 19.8219 7.59491 19.7505L3.80365 19.1098C2.69873 18.9231 2.03683 17.7766 2.42758 16.7264L3.76833 13.1227C3.91777 12.721 3.91777 12.279 3.76833 11.8773L2.42758 8.27363C2.03683 7.22338 2.69873 6.07694 3.80365 5.89021L7.59491 5.24949C8.01749 5.17808 8.40029 4.95707 8.67342 4.62682L11.1239 1.66384Z'
        fill='url(#paint0_linear_578_2853)'
      />
    </g>
    <defs>
      <filter
        id='filter0_d_578_2853'
        x='1.2275'
        y='1.01611'
        width='21.4581'
        height='24.0547'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='-1.08696' dy='1.08696' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.6875 0 0 0 0 0.532937 0 0 0 0 0.0601562 0 0 0 1 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_578_2853'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_578_2853'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_578_2853'
        x1='23.913'
        y1='-3.80435'
        x2='2.17391'
        y2='30.9783'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FDAA48' />
        <stop offset='1' stopColor='#FFD964' />
      </linearGradient>
    </defs>
  </svg>
);

export {
  BuildingIcon,
  UserIcon,
  CalendarIcon,
  CakeIcon,
  CommentUserIcon,
  BrowserIcon,
  PhoneIcon,
  LocationIcon,
  NoImageIcon,
  StarNoThingIcon,
  SuperStarIcons,
};
